/**
 * SeoShopByBrand Functional Component
 * @Package - seo
 * @Author - Cybage@UPWA-Team
 * @description: Common SEO SeoShopByBrand
 */
/**
 *   SEO's SeoShopByBrand Component
 */
import React, {
  useCallback, useContext, useEffect, useState,
} from 'react'
import { Title, LinkWithText } from '@usap/widgets'
import {
  AddIcon, Box, IcoMoon, RemoveIcon, useResponsiveWrapperContext,
} from '@usap/uicomponents'
import styled from 'styled-components'
import { LocalContext } from '../../helpers/useLocalContext'
import seoIds from '../../../config/seoIds'
import PageTypeIdentifier from '../../helpers/PageTypeIdentifier'

const CollapseBox = styled(Box)`
  cursor: pointer;
`

const MainContainer = styled(Box)`
  padding: 12px;
`

const HeadingSection = styled(Box)`
  @media (max-width: 1024px) {
    flex-direction: row;
    align-self: flex-start;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    margin-left: 0;
    margin-right: 0;
  }
`
export default function SeoShopByBrand({
  id,
  data,
  title,
}) {
  const { isDesktop } = useResponsiveWrapperContext()
  const { localContext } = useContext(LocalContext)
  const { Link } = localContext

  const [isDisplay, setIsDisplay] = useState(true)
  const handleClick = useCallback(() => PageTypeIdentifier.brandPart(), [])

  const handleAccordion = useCallback(() => {
    if (isDisplay) {
      setIsDisplay(false)
    } else {
      setIsDisplay(true)
    }
  }, [isDisplay])

  useEffect(() => {
    if (!isDesktop) {
      setIsDisplay(false)
    } else {
      setIsDisplay(true)
    }
  }, [isDesktop])

  const colWidth = isDesktop ? '12.50%' : '33.33%'

  return (
    <Box background="light-1">
      <MainContainer
        id={id}
        width="1248px"
        margin={{ horizontal: 'auto', vertical: '0px' }}
      >
        <HeadingSection
          id="ShopByBrandHeading"
          margin={{ horizontal: 'small' }}
        >
          {/* Title for the ShopByBrand Component */}
          <Title
            type="h2"
            size={isDesktop ? 'medium' : 'small'}
            label={title}
            style={{ fontSize: '20px' }}
          />
          {
            !isDesktop && (
              <CollapseBox onClick={handleAccordion}>
                <IcoMoon icon={isDisplay ? RemoveIcon : AddIcon} color="#393939" />
              </CollapseBox>
            )
          }
        </HeadingSection>
        {
          isDisplay && (
            <LinkWithText
              gridId="ShopByBrandSection"
              elementId={seoIds.shopByBrand}
              data={data}
              colWidth={colWidth}
              Link={Link}
              handleClick={handleClick}
            />
          )
        }
      </MainContainer>
    </Box>
  )
}
